<template>
  <div>
    <div class="row">
      <div class="col-md-12">

        <div class="form-group">
          <label for="scraping-service-name">Name</label>
          <input v-model="scrapingService.name" class="form-control" id="scraping-service-name" :disabled="!editable">
        </div>

        <div class="form-group">
          <label for="scraping-service-scraper-name">ScraperName</label>
          <input v-model="scrapingService.scraperName" class="form-control" id="scraping-service-scraper-name" :disabled="!editable">
        </div>

        <div class="form-group">
          <label for="scraping-service-enable">Enable ?</label>
          <input v-model="scrapingService.enable" type="checkbox" id="scraping-service-enable" class="ml-2" :disabled="!editable">
        </div>

        <div class="form-group">
          <label for="scraping-service-default" title="Quando ativo é elegivél para ser associado a um veículo">Default ?</label>
          <input v-model="scrapingService.default" type="checkbox" id="scraping-service-default" class="ml-2" :disabled="!editable">
        </div>
        
        <div class="form-group">
          <label for="scraping-service-app-name">App name</label>
          <select v-model="scrapingService.appName" class="form-control" id="scraping-service-app-name" :disabled="!editable">
            <option value="cm-crono">cm-crono</option>
            <option value="cm-frotas">cm-frotas</option>
            <option value="cm-embarcador">cm-embarcador</option>
            <option value="cm-taxas">cm-taxas</option>
          </select>
        </div>

        <div class="form-group">
          <label for="scraping-service-validate-fields">Validate Fields</label>
          <Select2
            id="scraping-service-validate-fields"
            v-model="scrapingService.validateFields"
            :options="validateFields"
            :disabled="!editable"
          />
        </div>

        <div class="form-group">
          <label for="scraping-service-executor">Executor</label>
          <select v-model="scrapingService.executor" class="form-control" id="scraping-service-executor" :disabled="!editable">
            <option value="Robot">Robot</option>
            <option value="Infosimples">Infosimples</option>
          </select>
        </div>

        <div class="form-group">
          <label for="scraping-service-friendly-name">Friendly name</label>
          <input v-model="scrapingService.friendlyName" class="form-control" id="scraping-service-friendly-name" :disabled="!editable">
        </div>

        <div class="form-group">
          <label for="scraping-service-sphere">Sphere</label>
          <select v-model="scrapingService.sphere" class="form-control" id="scraping-service-sphere" :disabled="!editable">
            <option value="federal">Federal</option>
            <option value="state">State</option>
            <option value="municipal">Municipal</option>
          </select>
        </div>

        <div class="form-group">
          <label for="scraping-service-uf">UF</label>
          <select v-model="scrapingService.uf" class="form-control" id="scraping-service-uf" :disabled="!editable">
            <option :value="null">-</option>
            <option :value="uf" :key="uf" v-for="uf in listUF">
              {{ uf }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="scraping-service-amount-retry">Amount retry</label>
          <input v-model="scrapingService.amountRetry" type="number" class="form-control" id="scraping-service-amount-retry" :disabled="!editable">
        </div>

        <div class="form-group">
          <label for="scraping-service-proxy-name">ProxyName</label>
          <input v-model="scrapingService.proxyName" class="form-control" id="scraping-service-proxy-name" :disabled="!editable">
        </div>

        <div class="form-group">
          <label for="scraping-service-description">Description</label>
          <textarea v-model="scrapingService.description" class="form-control" id="scraping-service-description" :disabled="!editable"/>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="col-md-12 text-right">
        <button class="btn btn-outline mr-2" @click="cancel">Cancelar</button>
        <button v-if="editable" class="btn btn-primary" @click="save" :disabled="disabledSaveButton">Salvar</button>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from '@/components/shares/Select2'

const validateFields = [
        'chassi', 'cnpj', 'cpf', 'cpf_cnpj', 'login',
        'password', 'plate', 'renavam', 'security_code', 'certificate_base64'
      ].sort()

export default {
  components: { Select2 },
  computed: {
    disabledSaveButton() {
      return !this.scrapingService.name ||
             !this.scrapingService.scraperName
    },
    validateFields() {
      if (this.scrapingService.appName === 'cm-embarcador')
        return ['certificate_base64', 'login', 'password']
      else 
        return validateFields
    }
  },
  data: () => ({
    listUF: ['AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO'],
  }),
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    save() {
      this.$emit('saveEntity', this.scrapingService)
    },
  },
  mounted() {
    this.scrapingService.enable = !!this.scrapingService.enable
  },
  name: 'Form',
  props: {
    scrapingService: { required: true, type: Object },
    editable: { default: false, type: Boolean },
  }
}

</script>

<style scoped>

</style>
